import * as React from "react";

interface IMenuButton {
  id: string;
  label: string;
  path: string;
  icon?: string;
  menuType: string;
  targetBlank?: boolean;
}

export interface MenuActions {
  registerMenuCustom?(key: string, button: IMenuButton, state?: unknown): void;
  unregisterMenuCustom?(key: string): void;
  registerSubmenuCustom?(
    menuKey: string,
    submenuKey: string,
    button: Omit<IMenuButton, "menuType">,
    state?: unknown
  ): void;
  unregisterSubmenuCustom?(menuKey: string, submenuKey: string): void;
  toggleMenu?(): void;
  hideMenu?(): void;
  showMenu?(): void;
}

interface MenuContextProviderProps {
  value: MenuActions;
  children: React.ReactNode;
}

export const MenuContext = React.createContext<MenuActions>({});

export const useMenuContext = () => React.useContext(MenuContext);

export const MenuContextProvider = (props: MenuContextProviderProps) => (
  <MenuContext.Provider value={props.value}>{props.children}</MenuContext.Provider>
);
